<div class="container-radio-buttons">
  @for (paymentMethod of paymentMethods; track $index) {
    @switch (paymentMethod) {
      @case ('SEPA') {
        <ez-payment-method-selection-element
          [controlName]="controlName"
          [value]="paymentMethod"
          label="Einzugsermächtigung"
          iconSrc="assets/icons/sepa.png"
          popoverText="Teilen Sie uns Ihre IBAN mit. Wir übernehmen den Rest und buchen diesen und alle folgenden Beiträge einfach und bequem von Ihrem Konto ab."
        ></ez-payment-method-selection-element>
      }
      @case ('GIRO') {
        <ez-payment-method-selection-element
          [controlName]="controlName"
          [value]="paymentMethod"
          label="Direktüberweisung"
          iconSrc="assets/icons/sepa.png"
          popoverText="TODO"
        ></ez-payment-method-selection-element>
      }
      @case ('CREDIT_CARD') {
        <ez-payment-method-selection-element
          [controlName]="controlName"
          [value]="paymentMethod"
          label="Kreditkarte"
          iconSrc="assets/icons/sepa.png"
          popoverText="TODO"
        ></ez-payment-method-selection-element>
      }
      @case ('PAYPAL') {
        <ez-payment-method-selection-element
          [controlName]="controlName"
          [value]="paymentMethod"
          label="PayPal"
          iconSrc="assets/icons/sepa.png"
          popoverText="TODO"
        ></ez-payment-method-selection-element>
      }
    }
  }
</div>
